'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _getCookie = require('../utils/getCookie');

var _getCookie2 = _interopRequireDefault(_getCookie);

var _urls = require('../utils/urls');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HomeDAO = function () {
  function HomeDAO() {
    _classCallCheck(this, HomeDAO);
  }

  _createClass(HomeDAO, null, [{
    key: 'get',
    value: function get() {
      var portalIdFromQueryParam = _hubspot2.default.getPortalIdFromQueryParam();
      var portalIdForUser = portalIdFromQueryParam || _hubspot2.default.getPortalIdFromCookie();
      var apiPath = portalIdFromQueryParam ? '/home/v2/api' : '/home/v2/api/no-intended-portal';
      var params = portalIdFromQueryParam ? { portalId: portalIdForUser } : {};
      var zorseParamExists = window.location.search && window.location.search.indexOf('autoOpenZorseCreateView') !== -1;
      if (zorseParamExists) {
        params.autoOpenZorseCreateView = true;
      }
      return _jquery2.default.ajax((0, _urls.api)(apiPath), {
        data: params,
        headers: { 'X-HubSpot-CSRF-hubspotapi': (0, _getCookie2.default)('csrf.app') },
        xhrFields: {
          withCredentials: true
        }
      });
    }
  }]);

  return HomeDAO;
}();

exports.default = HomeDAO;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/data/HomeDAO.js
// module id = 40
// module chunks = 1